export const EMOJI_PICKER_TRANSLATION = {
    search: 'Recherche',
    emojilist: 'Liste des emojis',
    notfound: 'Aucune emoji trouvée',
    clear: 'Vider',
    categories: {
        search: 'Résultats',
        recent: 'Fréquents',
        people: 'Sourires & Personnes',
        nature: 'Animaux & Nature',
        foods: 'Nourriture & Boissons',
        activity: 'Activités',
        places: 'Voyage & Lieux',
        objects: 'Objets',
        symbols: 'Symboles',
        flags: 'Drapeaux',
        custom: 'Autres',
    },
    skintones: {
        1: 'Ton de peau par défaut',
        2: 'Peau claire',
        3: 'Ton de peau mi-clair',
        4: 'Ton de peau clair',
        5: 'Ton de peau mi-foncé',
        6: 'Ton de peau foncé',
    },
};

export const EMOJI_PICKER_TRANSLATION_EN = {
    search: 'Search',
    emojilist: 'List of emoji',
    notfound: 'No Emoji Found',
    clear: 'Clear',
    categories: {
        search: 'Search Results',
        recent: 'Frequently Used',
        people: 'Smileys & People',
        nature: 'Animals & Nature',
        foods: 'Food & Drink',
        activity: 'Activity',
        places: 'Travel & Places',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags',
        custom: 'Custom',
    },
    skintones: {
        1: 'Default Skin Tone',
        2: 'Light Skin Tone',
        3: 'Medium-Light Skin Tone',
        4: 'Medium Skin Tone',
        5: 'Medium-Dark Skin Tone',
        6: 'Dark Skin Tone',
    },
};
